import React from 'react'
import { Link } from 'react-router-dom';
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { usePlans } from '../../Hook/App';
import Spinner from '../../Components/Spinner';

function Index() {
    const { navigate, price, tax, total, select, loading, plans, plan, payment } = usePlans();
    return (
        <Layout>
            <HeaderMain lable="ویژه کردن آگهی" leftitem={<div className='not-now' style={{ cursor: "pointer" }} onClick={() => { navigate(-1) }}>  فعلا نه  </div>} />
            <div className='text-introdaction  mb-5'>با امکانات زیر بازدید اگهی خود را افزایش دهید</div>
            <div className='pb-5 '>            {
                loading.plans ?
                    <Spinner />
                    :
                    plans && plans.map((plan, i) => {
                        return (
                            <div className='card-one'>
                                <div className='d-flex align-items-center'>
                                    <div className='img-visited '>
                                        <i className='far fa-box-open mx-4' style={{ fontSize: 30 }}></i>
                                    </div>
                                    <div className='px-3 py-3 w-100'>
                                        <div className='d-flex align-items-center justify-content-between content-card'>
                                            <div className="form-group">
                                                <input type="radio" name="plan" onClick={() => { select(plan) }} />
                                                <label >{plan.title}</label>
                                            </div>
                                        </div>
                                        <p>{plan.description}</p>
                                        <p>مدت زمان  : {plan.meta_data && plan.meta_data.time} روز</p>
                                        <div className='prise'> <span>{plan.meta_data && parseInt(plan.meta_data.price).toLocaleString()}</span> تومان </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
            }
                {
                    plan &&
                    <>
                        <div className='factore'>
                            <h3>خلاصه پرداخت</h3>
                            <div className='item-prise' >
                                <p>بسته انتخابی شما</p>
                                <span><span>{price.toLocaleString()}</span> تومان </span>
                            </div>

                            <div className='item-prise'>
                                <p>مالیات بر ارزش افزوده</p>
                                <span><span>{tax.toLocaleString()}</span> تومان </span>
                            </div>
                            <div className='item-end'>
                                <p>مبلغ کل</p>
                                <span><span>{total.toLocaleString()}</span> تومان </span>
                            </div>
                        </div>
                        <div className='notice-item'>
                            <i class="fas fa-exclamation-circle"></i>
                            <p>با پرداخت این مبلغ شما با  <Link to={"/Rule"}>قوانین و مقررات </Link>بوکان آگهی موافقت کرده اید</p>
                        </div>
                        <div className='btn-touche'>
                            <button onClick={payment} className=" mt-2 mb-2">پرداخت  <span>{total.toLocaleString()}</span> تومان</button>
                        </div>
                    </>
                }
            </div>

        </Layout>
    )
}

export default Index